import { render, staticRenderFns } from "./word-image-manage.vue?vue&type=template&id=37951ce5&scoped=true&"
import script from "./word-image-manage.vue?vue&type=script&lang=js&"
export * from "./word-image-manage.vue?vue&type=script&lang=js&"
import style0 from "./word-image-manage.vue?vue&type=style&index=0&id=37951ce5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37951ce5",
  null
  
)

export default component.exports